import React from 'react';
import { todayIso } from './transactionsMeta';

/**
 * Page-level state for the transactions page: the selected day (an ISO
 * `YYYY-MM-DD` string, defaulting to today). The list section reads the date
 * and re-fetches when it changes. Kept here so the page container and view stay
 * render-only.
 */
export const useTransactionsPage = () => {
    const [date, setDate] = React.useState<string>(todayIso);

    return {
        date,
        setDate,
    };
};

export type TransactionsPageLogic = ReturnType<typeof useTransactionsPage>;
